import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1cd33840&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=1cd33840&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd33840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd33840')) {
      api.createRecord('1cd33840', component.options)
    } else {
      api.reload('1cd33840', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1cd33840&scoped=true", function () {
      api.rerender('1cd33840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/recording/Index.vue"
export default component.exports